import { Kampos, noise, utilities } from 'kampos';
export default async function create(target, options) {
  const {
    radius = 0.4,
    spread = 1.0
  } = options.namedEffect;
  const circle = utilities.circle();
  const mouse = utilities.mouse({
    initial: {
      x: -0.5,
      y: -0.5
    }
  });
  const resolution = utilities.resolution({
    width: target.width,
    height: target.height
  });
  const render = {
    fragment: {
      uniform: {
        u_radius: 'float',
        u_spread: 'float',
        u_intensity: 'float'
      },
      constant: `
      ${noise.white}`,
      source: `
        float noiseValue = noise2(gl_FragCoord.xy);
        float ar_ = u_resolution.x / u_resolution.y;
        vec2 st_ = gl_FragCoord.xy / u_resolution;
        float c_ = circle(vec2(st_.x * ar_, st_.y), vec2(u_mouse.x * ar_, u_mouse.y), u_radius, u_spread + 0.1 * u_intensity) * 10.0 * u_intensity;
        sourceCoord += vec2(noiseValue - 0.5) * c_;`
    },
    uniforms: [{
      name: 'u_radius',
      type: 'f',
      data: [radius]
    }, {
      name: 'u_spread',
      type: 'f',
      data: [spread]
    }, {
      name: 'u_intensity',
      type: 'f',
      data: [1]
    }],
    get radius() {
      return this.uniforms[0].data[0];
    },
    set radius(r) {
      this.uniforms[0].data[0] = r;
    },
    get spread() {
      return this.uniforms[1].data[0];
    },
    set spread(s) {
      this.uniforms[1].data[0] = s;
    },
    get intensity() {
      return this.uniforms[2].data[0];
    },
    set intensity(i) {
      this.uniforms[2].data[0] = i;
    }
  };
  const instance = new Kampos({
    target,
    effects: [circle, resolution, mouse, render]
  });
  const FADE_FACTOR = 0.9;
  function calculateIntensity(velocity) {
    const target_ = instance.config.target;
    return Math.hypot(velocity.x / target_.width, velocity.y / target_.height);
  }
  return {
    instance,
    play(_temp) {
      let {
        beforeDraw
      } = _temp === void 0 ? {} : _temp;
      this.instance.play(beforeDraw);
    },
    setters: {
      mouse(p) {
        mouse.position = p;
        if (p.active === false) {
          const currentV = render.intensity;
          render.intensity = currentV > 0.01 ? currentV * FADE_FACTOR : 0;
        } else {
          render.intensity = calculateIntensity(p.v);
        }
      },
      radius(r) {
        render.radius = r;
      },
      spread(s) {
        render.spread = s;
      }
    },
    resize(w, h) {
      const size = {
        width: w,
        height: h
      };
      resolution.resolution = size;
      instance.setSource(size);
    }
  };
}
//# sourceMappingURL=NoisyTrack.js.map